import axiosInstance from "../api/axiosInstance";

// GET join guest list
// params: status, search, promoterId, hostId, clubId, userId, startDate, endDate,
//         sortBy, sortOrder, page, limit
export const fetchJoinGuestLists = (params) =>
  axiosInstance.get("/admin/joinguestlists", { params });

export const fetchGuestLists = (params) =>
  axiosInstance.get("/admin/guestList", { params });

export const fetchScannedGuestLists = (params) =>
  axiosInstance.get("/admin/scannedguestlists", { params });

// Filter dropdown sources
export const fetchJoinGuestClubs = () =>
  axiosInstance.get("/admin/joinguestlists/clubs");

export const fetchJoinGuestHosts = () =>
  axiosInstance.get("/admin/joinguestlists/hosts");

export const fetchJoinGuestPromoters = () =>
  axiosInstance.get("/admin/joinguestlists/promoters");

export const fetchJoinGuestUsers = () =>
  axiosInstance.get("/admin/joinguestlists/users");
